import TranslatedErrorBoundary from "@/components/ErrorBoundary/errorBoundary.component";
import CompaniesDetailsForm from "@/components/ViewProfile/CompaniesDetails/companiesDetailsForm.component";
import UserDetailsForm from "@/components/ViewProfile/UserDetails/userDetailsForm.component";
import { fetchUserProfile } from "@/models/socket/user.model";
import { UserProfileResponse } from "@/types";
import React, { useEffect, useState } from "react";

const ViewProfile: React.FC = () => {
  const [userProfile, setUserProfile] = useState<UserProfileResponse | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  async function fetchProfile() {
    setLoading(true);
    setError(null);
    try {
      const response = await fetchUserProfile();
      if (response.rStatus === "error") {
        throw new Error(response.rData);
      }
      console.log("User Profile Data:", response.rData);
      setUserProfile(response.rData);
    } catch (err) {
      setError(err instanceof Error ? err.message : "Unknown error");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchProfile();
  }, []);

  return loading ? (
    <div className="py-4">
      <div className="flex items-center justify-center">
        <div className="h-10 w-10 animate-spin rounded-full border-b-3 border-white"></div>
      </div>
      <div className="flex items-center justify-center">
        <h2 className="mt-2 text-xl text-white">Loading Profile...</h2>
      </div>
    </div>
  ) : error ? (
    <div className="flex h-full items-center justify-center">
      <p className="text-red-500">{error}</p>
    </div>
  ) : !userProfile ? null : (
    <div className="p-4">
      {/* <h1 className="mb-4 text-2xl font-bold">User Profile</h1> */}
      <div className="grid grid-cols-1 gap-4">
        <TranslatedErrorBoundary>
          <UserDetailsForm initialDetails={userProfile} />
        </TranslatedErrorBoundary>
        <TranslatedErrorBoundary>
          <CompaniesDetailsForm
            initialDetails={userProfile.companies}
            fetchProfile={fetchProfile}
          />
        </TranslatedErrorBoundary>
      </div>
    </div>
  );
};

export default ViewProfile;
